import {getSequenceStatusLabelKey} from '@/modules/patients-therapies/functions'
import {useSequenceJourneyState} from '@/modules/patients-therapies/hooks'
import {useGetSettings} from '@/modules/settings/api'
import {isPatientArrivalEnabled} from '@/modules/settings/functions'
import {Badge, Text} from '@chakra-ui/react'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {Tooltip} from '@cypro/ui/components'
import {useTranslate} from '@tolgee/react'

export function StatusBadge({sequence}: {sequence: PatientTherapySequence}) {
  const {t: tActivity} = useTranslate('activity')
  const {settings} = useGetSettings()
  const journey = useSequenceJourneyState(sequence)
  const palette = journey.getStepState(journey.currentPhaseKey).color?.split('.')?.[0]
  const statusKey = getSequenceStatusLabelKey(sequence, isPatientArrivalEnabled(settings))

  if (!statusKey) return null

  return (
    <Tooltip content={tActivity(`${statusKey}.description`)}>
      <Badge size="sm" variant="surface" colorPalette={palette}>
        <Text>{tActivity(`${statusKey}.title`)}</Text>
      </Badge>
    </Tooltip>
  )
}
